import { ArrowRight, Sparkles } from "lucide-react";
import { aiTools } from "../toolCatalog";

export default function AIToolsPreview() {
  return (
    <section className="ai-preview" aria-labelledby="ai-preview-title">
      <header className="ai-preview__heading">
        <div>
          <p>New, with careful AI</p>
          <h2 id="ai-preview-title">A little help shaping your own words.</h2>
        </div>
        <p>
          These tools use GPT-5 nano for one bounded task. They do not diagnose, prescribe,
          or replace a conversation with a qualified professional.
        </p>
      </header>
      <figure className="ai-preview__illustration">
        <img src="/images/illustrations/shaping-words.jpg" alt="A pencil and loose ink line resolving into three clear handmade paper panels" width="1536" height="1024" loading="lazy" />
        <figcaption>The tool can help with structure. The meaning and the final words stay yours.</figcaption>
      </figure>
      <div className="ai-preview__list">
        {aiTools.map((tool) => (
          <a className={`ai-preview__item ai-preview__item--${tool.tone}`} href={tool.path} key={tool.id}>
            <Sparkles size={21} aria-hidden="true" />
            <span>
              <strong>{tool.title}</strong>
              <small>{tool.description}</small>
            </span>
            <ArrowRight size={19} aria-hidden="true" />
          </a>
        ))}
      </div>
      <p className="ai-preview__privacy">Your entry is processed for the response and is not saved by this website.</p>
    </section>
  );
}
